import { STORAGE_PREFIX } from '@console/shared/src/constants/common';

export const LAST_PERSPECTIVE_USER_SETTINGS_KEY = 'console.lastPerspective';
export const LAST_PERSPECTIVE_LOCAL_STORAGE_KEY = `bridge/last-perspective`;
export const HIDE_USER_WORKLOAD_NOTIFICATIONS_USER_SETTINGS_KEY =
  'console.hideUserWorkloadNotifications';
export const FLAG_DEVELOPER_PERSPECTIVE = 'DEVELOPER_PERSPECTIVE';
export const ACM_PERSPECTIVE_ID = 'acm';
export const ADMIN_PERSPECTIVE_ID = 'admin';
export const FLAG_CAN_GET_CONSOLE_OPERATOR_CONFIG = 'CAN_GET_CONSOLE_OPERATOR_CONFIG';

export const FAVORITES_CONFIG_MAP_KEY = 'console.favorites';
export const FAVORITES_LOCAL_STORAGE_KEY = `${STORAGE_PREFIX}/favorites`;
